/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  showHashTag: ['data'],

})

export const FootterWallTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  error: null,
  isonHashtag : null,
  hastagIndex : 0
})

/* ------------- Selectors ------------- */

export const FootterWallSelectors = {
  getData: state => state.data
}

export const showHashTag = (state, action) => {
  console.tron.display({
    name: `showHashTag`,
     preview :``,
    value: {
    state: action
    }
    })
  const { data: { data,isonHashtag,hastagIndex } } = action
  
  
  return state.merge({ data ,isonHashtag,hastagIndex})
}




export const reducer = createReducer(INITIAL_STATE, {
  [Types.SHOW_HASH_TAG]: showHashTag,

})
